
import Cell from "overprint/overprint/cell";
import Palette from "./palette";

// ⌖
// Ш

// 🞠	🞡	🞢	🞣	🞤	🞥	🞦	🞧	🞨	🞩	🞪	🞫	🞬	🞭	🞮	🞯
// 🞐	🞑	🞒	🞓	🞔	🞕	🞖	🞗	🞘	🞙	🞚	🞛	🞜	🞝	🞞	🞟
// 🞀	🞁	🞂	🞃	🞄	🞅	🞆	🞇	🞈	🞉	🞊	🞋	🞌	🞍	🞎	🞏
// 	🟀	🟁	🟂	🟃	🟄	🟅	🟆	🟇	🟈	🟉	🟊	🟋	🟌	🟍	🟎	🟏
// 	🞰	🞱	🞲	🞳	🞴	🞵	🞶	🞷	🞸	🞹	🞺	🞻	🞼	🞽	🞾	🞿

// 🟰
//
// ❰	❱	❲	❳	❴	❵
// ❨	❩	❪	❫	❬	❭	❮	❯
// ✰	✱	✲	✳	✴	✵	✶	✷	✸	✹	✺	✻	✼	✽	✾	✿ ✠	✡	✢	✣	✤	✥	✦	✧
// ❀	❁	❂	❃	❄	❅	❆	❇	❈	❉	❊	❋ ✪	✫	✬	✭	✮	✯
// ❖
// ❐	❑	❒ ❍
// ❘	❙	❚	❛	❜	❝	❞	❟
// ✑	✒	✓	✔	✕	✖	✗	✘	✙	✚	✛	✜	✝	✞	✟
//
//
//₠	₡	₢	₣	₤	₥	₦	₧	₨	₩	₪	₫	€	₭	₮	₯
//₰	₱	₲	₳	₴	₵	₶	₷	₸	₹	₺	₻	₼	₽	₾	₿
//
//†	‡
//†	•	‣	․	‥	…	‧
//†	‒	–	—	―	‖	‗	‘	’	‚	‛	“	”	„	‟
//‰	‱	′	″	‴	‵	‶	‷	‸	‹	›	※	‼	‽	‾	‿
//	⁀	⁁	⁂	⁃	⁄	⁅	⁆	⁇	⁈	⁉	⁊	⁋	⁌	⁍	⁎	⁏
//⁐	⁑	⁒	⁓	⁔	⁕	⁖	⁗	⁘	⁙	⁚	⁛	⁜	⁝	⁞
//⁐
//🗤	🗥	🗦	🗧
//
//⩨	⩩ ⨳ ⌗

const Glyphs = {
  UI: {
    LookCursor: Cell("?", Palette.Pitch, Palette.Argent),
    TargetCursorValid: Cell("⯍", Palette.Pitch, Palette.Argent),
    TargetCursorBlocked: Cell("⯏", Palette.Pitch, Palette.Argent),
    TargetCursorBlank: Cell(" ", Palette.Pitch, Palette.Argent),
    TargetCursorTrail: Cell("•", Palette.Argent)
  },

  // Test stuff
  TargetDrone: Cell("T", Palette.Argent),

  // ⧃
  // ⵙ
  // ⧂
  // Hand mirror concepts to test
  Rondel: Cell("ⵙ", Palette.Argent),
  CircleDash: Cell("⧃", Palette.Argent),
  CircleBulb: Cell("⧂", Palette.Argent),

  // Item concepts
  MusicBox: Cell("⯴", Palette.Argent),
  Fishhook: Cell("~", Palette.Ashen),
  Artefact: Cell("&", Palette.Argent),
  Coin: Cell("*", Palette.Ashen),

  Seeds: Cell("⁖", Palette.Brown4),

  Object: Cell("!", Palette.Ashen),
  IronNail: Cell("⫮", Palette.Carbonate4),
  CrackedPot: Cell("◕", Palette.Rouge2),
  RatSkull: Cell("⦔", Palette.Sand2),
  EbonyComb: Cell("∍", Palette.Ashen),
  EyeballJar: Cell("⊡", Palette.Rose1),

  // Armor
  LeatherArmor: Cell("Ω", Palette.Brown2),
  HornedHelm: Cell("℧", Palette.Copper2),
  Chainmail: Cell("₴", Palette.Gray2),

  // Weapons
  Sword: Cell("[", Palette.Argent),
  ShortBow: Cell("⟭", Palette.Argent),
  RecurveBow: Cell("⦄", Palette.Ashen),
  LongBow: Cell("⦆", Palette.Argent),
  Crossbow: Cell("⧕", Palette.Argent),
  Crossbow2: Cell("⎆", Palette.Argent),
  Glaive: Cell("⦍", Palette.Copper2),
  Staff: Cell("⟅", Palette.Brown3),
  Spear: Cell("/", Palette.BurntGreen3),
  Axe: Cell("₸", Palette.Brown3),
  Greataxe: Cell("₸", Palette.Copper2),
  Flail: Cell("₹", Palette.Brown4),

  // Ammunition
  // ↥
  BluntArrow: Cell("⤜", Palette.Brown3),
  BarbedArrow: Cell("↣", Palette.Brown3),
  BoltArrow: Cell("↦", Palette.Brown3),

  // Player
  Player: Cell("@", Palette.Argent),
  PlayerGiantGaze: Cell("@", Palette.Evoke2),
  PlayerPetrified: Cell("@", Palette.Evoke1, Palette.Evoke2),

  // Animals
  Sheep: Cell("e", Palette.Argent),
  Rat: Cell("r", Palette.Gray1),
  Bat: Cell("v", Palette.Shadow),
  MoleRat: Cell("r", Palette.Gray2),
  Fox: Cell("f", Palette.Ochre1),
  CaveSlug: Cell("u", Palette.BurntGreen3),
  GiantSlug: Cell("U", Palette.BurntGreen3),
  CaveSpider1: Cell("s", Palette.Shadow),
  CaveSpider2: Cell("s", Palette.Gray1),
  GiantSpider1: Cell("S", Palette.Shadow),
  GiantSpider2: Cell("S", Palette.Gray1),

  // Monsters
  KoboldBeserker: Cell("𝝹", Palette.Ochre2),
  KoboldSharpshooter: Cell("𝝹", Palette.Rouge2),
  GorgonGiant: Cell("Ơ", Palette.Argent),
  GorgonGiantAttack: Cell("Ơ", Palette.Evoke2),

  // Chasm and backdrop
  Void: Cell(" ", Palette.Pitch, Palette.Pitch),
  Chasm: Cell(".", Palette.Shadow, Palette.Pitch),

  // Levels
  CandleForYourFather: Cell("⍦", Palette.Farmlet.Candle, Palette.Shadow),
  Emblem: Cell("У", Palette.Farmlet.Candle, Palette.Farmlet.Tablecloth),
  Wall: Cell("⌆", Palette.Farmlet.Floor1, Palette.Farmlet.Daub),
  Chimney: Cell("⩨", Palette.Shadow, Palette.Ashen),
  Field1: Cell(".", Palette.BurntGreen2, Palette.BurntGreen3),
  Field2: Cell(",", Palette.GrassGreen2, Palette.BurntGreen3),
  Field3: Cell(".", Palette.Hay2, Palette.BurntGreen3),
  Swale: Cell("~", Palette.TealBlue1, Palette.BurntGreen3),
  Trees1: Cell("✱", Palette.LushGreen3, Palette.GrassGreen2),
  Trees2: Cell("✲", Palette.GrassGreen2, Palette.GrassGreen1),
  Trees3: Cell("✤", Palette.LushGreen2, Palette.LushGreen1),
  Fence: Cell("=", Palette.BurntGreen3, Palette.BurntGreen2),
  Furrow: Cell(".", Palette.Brown2, Palette.Brown3),
  Cabbages: Cell("⁙", Palette.GrassGreen4, Palette.Brown3),
  House: Cell("⌯", Palette.Farmlet.Daub, Palette.Farmlet.Whitewash),
  Floor: Cell(":", Palette.Farmlet.Floor2, Palette.Farmlet.Floor1),
  CottageDoor: Cell("/", Palette.Farmlet.DoorTrim, Palette.Farmlet.DoorPaint),
  ClosedCottageDoor: Cell("+", Palette.Farmlet.DoorTrim, Palette.Farmlet.DoorPaint),

  ForestPath: Cell(">", Palette.LushGreen4, Palette.GrassGreen2),

  Forest1: Cell("♣", Palette.LushGreen2, Palette.GrassGreen1),
  Forest2: Cell("✱", Palette.GrassGreen2, Palette.BurntGreen1),
  ForestFloor1: Cell(".", Palette.BurntGreen2, Palette.Hay1),
  ForestFloor2: Cell(".", Palette.GrassGreen2, Palette.Hay1),
  ForestFloor3: Cell(".", Palette.Brown2, Palette.Hay1),
  ForestFloor4: Cell("‥", Palette.BurntGreen2, Palette.Hay1),
  ForestFloor5: Cell("‥", Palette.GrassGreen2, Palette.Hay1),
  ForestFloor6: Cell(".", Palette.BurntGreen2, Palette.Hay1),
  ForestEntrance: Cell("<", Palette.BurntGreen2, Palette.Hay1),
  ForestExit: Cell(">", Palette.BurntGreen2, Palette.Hay1),

  CarbonateCave: Cell(".", Palette.Carbonate3, Palette.Carbonate4),
  CarbonateRock1: Cell("✚", Palette.Carbonate2, Palette.Carbonate1),
  CarbonateRock2: Cell("✚", Palette.Carbonate3, Palette.Carbonate2),
  CarbonateRock3: Cell("✜", Palette.Carbonate2, Palette.Carbonate1),
  CarbonateRock4: Cell("✜", Palette.Carbonate3, Palette.Carbonate2),
  CarbonateEntrance: Cell("<", Palette.Carbonate3, Palette.Carbonate4),
  CarbonateExit: Cell(">", Palette.Carbonate3, Palette.Carbonate4),

  SlateCave: Cell(".", Palette.Slate3, Palette.Slate4),
  SlateRock1: Cell("✚", Palette.Slate2, Palette.Slate1),
  SlateRock2: Cell("✚", Palette.Slate3, Palette.Slate2),
  SlateRock3: Cell("✜", Palette.Slate2, Palette.Slate1),
  SlateRock4: Cell("✜", Palette.Slate3, Palette.Slate2),
  SlateEntrance: Cell("<", Palette.Slate3, Palette.Slate4),
  SlateExit: Cell(">", Palette.Slate3, Palette.Slate4),

  LimestoneCave: Cell(".", Palette.Limestone3, Palette.Limestone4),
  LimestoneRock1: Cell("✚", Palette.Limestone2, Palette.Limestone1),
  LimestoneRock2: Cell("✚", Palette.Limestone3, Palette.Limestone2),
  LimestoneRock3: Cell("✜", Palette.Limestone2, Palette.Limestone1),
  LimestoneRock4: Cell("✜", Palette.Limestone3, Palette.Limestone2),
  LimestoneEntrance: Cell("<", Palette.Limestone3, Palette.Limestone4),
  LimestoneExit: Cell(">", Palette.Limestone3, Palette.Limestone4),

  DungeonFlagstone: Cell("🞒", Palette.Slate3, Palette.Limestone4),
  RuinedWall1: Cell("𝟆", Palette.Slate3, Palette.Limestone2),
  RuinedWall2: Cell("𝟆", Palette.Limestone3, Palette.Slate2),
  RuinedWall3: Cell("𝟈", Palette.Slate3, Palette.Limestone2),
  RuinedWall4: Cell("𝟈", Palette.Limestone3, Palette.Slate2),

  KoboldStatue: Cell("k", Palette.Limestone4, Palette.Slate3),
  BardStatue: Cell("h", Palette.Slate4, Palette.Limestone3),
  AdventurerStatue: Cell("h", Palette.Limestone4, Palette.Slate3),
  PaladinStatue: Cell("p", Palette.Limestone4, Palette.Slate3),
  OrcStatue: Cell("o", Palette.Slate4, Palette.Limestone3),
  TrollStatue: Cell("t", Palette.Slate4, Palette.Limestone3),
  YourFather: Cell("t", Palette.Rose2, Palette.Rose1),

  BanquetTable: Cell("※", Palette.Rose2, Palette.Brown3),

  PoolOfTears: Cell("~", Palette.TealBlue1, Palette.Shadow)
}

window.glyphs = Glyphs;

export default Glyphs;
